import { useState } from 'react';
// @mui
import { Menu, Button, MenuItem, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useRef } from 'react';
import { t } from 'i18next';

// component

const RadioFilter = ({ filterType, setFilterType }) => {
    const [open, setOpen] = useState(false);
    const refAnchor = useRef(null);
    return (
        <>
            <Button
                color="inherit"
                disableRipple
                ref={refAnchor}
                onClick={() => setOpen(true)}
                setOpen={() => setOpen(true)}
                endIcon={<Iconify icon={open ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} />}
            >
                {t('filter_cell')}:&nbsp;
                <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
                    {t(filterType)}
                </Typography>
            </Button>
            <Menu
                keepMounted
                anchorEl={refAnchor.current}
                open={Boolean(open)}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem value="all" onClick={() => setFilterType('all')}>
                    {t('all')}
                </MenuItem>
                <MenuItem value="empty" onClick={() => setFilterType('empty')}>
                    {t('empty')}
                </MenuItem>
                <MenuItem value="empty_zero" onClick={() => setFilterType('empty_zero')}>
                    {t('empty_zero')}
                </MenuItem>
                <MenuItem value="has_device" onClick={() => setFilterType('has_device')}>
                    {t('has_device')}
                </MenuItem>
                <MenuItem value="has_device_gt_zero" onClick={() => setFilterType('has_device_gt_zero')}>
                    {t('has_device_gt_zero')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default RadioFilter;
